import { message } from 'antd'
import Tag from '~/components/shared/Tag'
import { formatRoleName } from '../../utils/index'
import { Box, Flex } from '@weareberyl/design-system'
import { useMemo } from 'react'
import {
  useRemoveRoleMutation,
  UserSummaryQuery_user_User_roles_Role,
} from '~/gql/generated/graphql'
import { TEXT_VARIANTS } from '@weareberyl/design-system/build/components/Typography/Text'
import { InternalRefetchQueriesInclude } from '@apollo/client'

const getRoleDescription = role => {
  let description = ''
  const roleName = formatRoleName(role.type.description)

  if (role.scheme) description = ' - ' + role.scheme.name || role.scheme.id
  if (role.org) description = ' - ' + role.org.name || role.org.id

  if (role.type.id === '0') {
    if (role.scheme || role.org) {
      return 'Scheme Admin' + description
    } else {
      return 'Beryl admin [deprecated]'
    }
  }

  if (role.type.id === '2' || role.type.id === '3' || role.type.id === '6') {
    return roleName
  }

  return roleName + description
}

interface IRoles {
  roles: UserSummaryQuery_user_User_roles_Role[]
  refetchQueries?: InternalRefetchQueriesInclude
  labelVariant?: keyof typeof TEXT_VARIANTS
  closable?: boolean
}

const Roles = ({
  roles,
  refetchQueries = [],
  labelVariant = 'micro',
  closable = false,
}: IRoles) => {
  const [executeRemoveRole] = useRemoveRoleMutation({
    onCompleted: () => message.info('Role removed'),
    refetchQueries,
    onError: err => message.error(`Something went wrong: ${err.message}`),
  })

  const sortedRoles = useMemo(
    () =>
      roles
        .map(r => ({ ...r, description: getRoleDescription(r) }))
        .slice(0)
        .sort((a, b) => (a.description > b.description ? 1 : 0)),
    [roles],
  )

  return (
    <Flex
      justifyContent="space-between"
      width="100%"
      flexDirection="column"
      style={{ gap: '20px' }}
    >
      <Box flexDirection="row" flexWrap="wrap">
        {sortedRoles.map(({ id, description }) => (
          <Tag
            closable={closable}
            onClose={() => executeRemoveRole({ variables: { role_id: id } })}
            label={description}
            labelVariant={labelVariant}
            key={id}
          />
        ))}
      </Box>
    </Flex>
  )
}

export default Roles
